export const shippingOptionServiceDetails = new Map([
  [
    '2',
    {
      name: 'SERVICE_DETAILS.STANDARD_TITLE',
      description: 'SERVICE_DETAILS.STANDARD_DESC',
    },
  ],
  [
    '4',
    {
      name: 'SERVICE_DETAILS.EXPRESS_TITLE',
      description: 'SERVICE_DETAILS.EXPRESS_DESC',
    },
  ],
]);
